// import VideoPage from "@/screens/VideoPage";
import dynamic from "next/dynamic";
const StoryPage = dynamic(() => import("@/screens/StoryPage"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));
// import StoryPage from "@/screens/StoryPage";
// import PageLayout from "@/screens/Layout/PageLayout";
import useIsMobile from "@/hooks/useIsMobile";

export default function Category({
  latestStoryData = null,
  latestVideoData = null,
  videoPageData = null,
  storyPageData = null
}) {
  
  const isMobileDevice = useIsMobile();
  return (
    <>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <StoryPage
          isMobileDevice={isMobileDevice}
          videoPageData={videoPageData}
          storyPageData = {storyPageData}
        />
        
      </PageLayout>
    </>
  );
}


export const getServerSideProps = async (ctx) => {
  
  
  const { logger } = await import("@/utils/logging/log-util");

  try {
    let url = ctx?.resolvedUrl;
    //* remove query param from url
    url = url.split("?")[0];

    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed, getContentByType } = await import(
      "@/handlers/content"
    );
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);
    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    //* get redis api key for each api
    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });
    const videosRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "newslist",
        page: page,
        display: 12,
        type: "video",
      },
    });

    const storiesRedisKey = getRedisApiKey({
        redisPrefix: "PREFIX_REDIS_ROS",
        params: {
          api: "newslist",
          page: page,
          display: 12,
          type: "all",
        },
      });
    
    let [{ latestStoryData, latestVideoData }, videoPageData , storyPageData] = await Promise.all([
      fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
      fetchRedisWrapper(videosRedisKey, () =>
        getContentByType({
          type: "video",
          page: page,
          display: 12,
        })
      ),
      fetchRedisWrapper(storiesRedisKey, () =>
        getContentByType({
          type: "all",
          page: page,
          display: 12,
        })
      ),
    ]);

    // if (!latestVideoData || Object.keys(latestVideoData).length === 0) {
    //   return {
    //     notFound: true,
    //   };
    // }
    // if (!latestVideoData || Object.keys(latestVideoData).length === 0) {
    //   return {
    //     notFound: true,
    //   };
    // }


    // console.log(videoPageData , ' data i want................................................');
    
    // let headerCache = videoPageData?.cache;
    // setPageTTL(ctx, headerCache?.akamai_ttl);
    let headerCache = storyPageData?.cache;
    setPageTTL(ctx, headerCache?.akamai_ttl);
     return {
      props: {
        latestStoryData,
        latestVideoData,
        videoPageData,
        videoPageData,
        storyPageData   ,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
